import * as React from "react";
import "whatwg-fetch";
import * as _ from "lodash";
import {
  IMobileMenuItemProps,
  IMobileMenuItemState,
} from "./MobileMenuItem.types";
import { MenuItem } from "./MobileMenu.types";

export class MobileMenuItem extends React.Component<
  IMobileMenuItemProps,
  IMobileMenuItemState
> {
  private menuItem: MenuItem;

  constructor(props: IMobileMenuItemProps) {
    super(props);

    this.menuItem = _.cloneDeep(this.props.menuItem);
  }

  public componentDidMount() {
    // If this item has children but not yet loaded we need to async load them into the object
    if (
      this.props.menuItem.HasChildren &&
      this.props.menuItem.Children.length === 0
    )
      this.fetchChildren(this.props.menuItem);
  }

  fetchChildren = (menuItem: MenuItem): MenuItem[] => {
    let menuItemChildren = [];

    fetch(
      "/_api/menu/getchildren?contentId=" +
        menuItem.Id +
        "&lang=" +
        this.props.language
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          menuItemChildren = res.data as MenuItem[];
          this.menuItem.Children = menuItemChildren;
          this.props.addChildrenToTreeCallback(
            this.menuItem.Children,
            this.props.menuItem.Id
          );
        })
    );
    return menuItemChildren;
  };

  onClickNextLevel = (menuItem: MenuItem) => {
    if (menuItem.Children.length > 0) {
      this.props.setActiveMenuItemCallback(menuItem, false);
    } else {
      console.log("Children not yet loaded?");
    }
  };

  public render() {
    const { menuItem, isStartPage } = this.props;
    const linkClassNames = `mobile-menu__nav-link ${
      menuItem.IsCurrentPage ? "current" : ""
    }`;
    return (
      <li className={"mobile-menu__menu-item"}>
        {this.props.menuItem.Url && !this.props.menuItem.IsContainerPage ? (
          <a className={linkClassNames} href={this.props.menuItem.Url}>
            {" "}
            {this.props.menuItem.Name}{" "}
          </a>
        ) : (
          <span className={linkClassNames + "addbold"}>
            {" "}
            {this.props.menuItem.Name}{" "}
          </span>
        )}
        {(this.menuItem.HasChildren ||
          this.menuItem.HasContainerPageChildren) && (
          <button
            onClick={() => this.onClickNextLevel(this.menuItem)}
            className={
              "mobile-menu__expand-menulevel chevron chevron--right" +
              (isStartPage ? " hide-navigate-arrow" : "")
            }
            aria-label={
              this.props.language == "en" ? "open subpages" : "Öppna undersidor"
            }
          />
        )}
      </li>
    );
  }
}
